import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'
import Psfs from 'lib/psfs/Psfs'
import {
  fetchLocusGroupLevelEventValues,
  fetchLocusGroupList,
} from 'reducers/logbookForm/reducer'
import { formattValues } from 'helpers/logbookForm'
import { TYPE_INPUT_BOOLEAN } from 'helpers/logbook'
import MasterEventField from './MasterEvent'

class LocusGroupList extends Component {
  componentDidMount() {
    this.fetchLocusGroupList(this.props)
  }

  shouldComponentUpdate(nextProps) {
    const { activeSite, activeDate, activeForm } = nextProps

    if (this.props.activeSite !== activeSite) {
      this.fetchLocusGroupList(nextProps)

      return false
    }

    if (
      (this.props.activeForm !== activeForm ||
        this.props.activeDate !== activeDate) &&
      activeForm &&
      !activeForm.needs_locus &&
      activeForm.events.length === 1
    ) {
      this.fetchLocusGroupLevelEventValues(nextProps)

      return false
    }

    return true
  }

  onItemClick = e => {
    const { onItemClick, locusGroupList } = this.props

    if (typeof onItemClick === 'function') {
      onItemClick(locusGroupList.get(e.currentTarget.dataset.index))
    }
  }

  fetchLocusGroupList = props => {
    const { activeSite } = props
    const psfs = new Psfs()
    psfs
      .addSort('name', 'asc')
      .addFilter('site', activeSite)
      .addFilter('visibleInUi', 1)
      .addFields(['id', 'name'])

    this.props.fetchLocusGroupList({ psfs })
  }

  fetchLocusGroupLevelEventValues = props => {
    const {
      activeDate,
      activeForm,
      locusGroupList,
      fetchLocusGroupLevelEventValues,
    } = props

    fetchLocusGroupLevelEventValues({
      params: {
        form: activeForm.id,
        date: activeDate.utc().format('YYYY-MM-DD'),
        event: activeForm.events[0].id,
        locus_groups: locusGroupList.map(item => item.id).toArray(),
      },
    })
  }

  render() {
    if (!this.props.isShow) {
      return null
    }

    const {
      activeItem,
      activeForm,
      activeAllEvents,
      activeEvent,
      onEventValueChange,
      onEventClick,
      locusGroupList,
      locusGroupEventValues,
    } = this.props
    const locusGroupListArray = locusGroupList.toArray()
    const locusGroupEventValuesArray = formattValues(
      locusGroupEventValues.toArray(),
      'locus_group_id',
    )

    return (
      <List disablePadding component="div" className="lbf-list">
        {locusGroupListArray.map((item, index) => {
          const { events, needs_locus } = activeForm
          const isEventOpen = activeEvent === item.id
          const onlyOneEvent = Array.isArray(events) && events.length === 1
          const hasSlaveEvents = onlyOneEvent && Array.isArray(events[0].slaves)
          const isLastLevelList =
            !needs_locus && onlyOneEvent && !hasSlaveEvents
          const clickHandler = hasSlaveEvents
            ? e => onEventClick(e, item.id)
            : null
          const onClick =
            !isLastLevelList || hasSlaveEvents ? this.onItemClick : clickHandler
          const selected = activeItem && activeItem.id === item.id

          return (
            <ListItem
              button
              key={`${item.id}_${index}`}
              data-index={index}
              onClick={onClick}
              className={cn('lbf-list-item', {
                'lbf-event-boolean':
                  TYPE_INPUT_BOOLEAN === (onlyOneEvent && events[0].type),
                'lbf-event-item': isLastLevelList,
                active: hasSlaveEvents && (isEventOpen || activeAllEvents),
                selected,
              })}>
              <ListItemText primary={item.name} />
              {isLastLevelList && !hasSlaveEvents && (
                <MasterEventField
                  index={index}
                  isEventOpen={isEventOpen || activeAllEvents}
                  hideTitle
                  eventInfo={{
                    ...events[0],
                    ...locusGroupEventValuesArray[item.id],
                    activeForm,
                    activeLocusGroup: item,
                  }}
                  onEventValueChange={onEventValueChange}
                  updateValuesList={() =>
                    this.fetchLocusGroupLevelEventValues(this.props)
                  }
                />
              )}
            </ListItem>
          )
        })}
      </List>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['logbookForm', 'activeDate']),
    locusGroupList: state.getIn(['logbookForm', 'locusGroupList']),
    locusGroupEventValues: state.getIn([
      'logbookForm',
      'locusGroupEventValues',
    ]),
  }),
  {
    fetchLocusGroupList,
    fetchLocusGroupLevelEventValues,
  },
)(LocusGroupList)
